
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[slug]",
      function () {
        return require("private-next-pages/news/category/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/category/[slug]"])
      });
    }
  